import { baseApi } from "./index";

export const helpApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        postContact: builder.mutation({
            query: (body) => ({
                url: "/help-center",
                method: "POST",
                data: body,
            }),
        }),
        getFaq: builder.query({
            query: ({ locale }) => ({
                url: `faq-esg`,
                method: "GET",
                params: {
                    locale,
                },
            }),
            providesTags: ["Faq"],
        }),
    }),
});

export const { usePostContactMutation, useGetFaqQuery } = helpApi;
